import apiConfig from "../../config/apiConfig";
import { objToQueryString } from "../../services/helpers/Helper";
import { COMMENT_TYPE, END_POINT } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const receiveMessages = (body) =>
   async (dispatch) => {
      dispatch({
         type: COMMENT_TYPE.ADD,
         payload: body
      })
   }

export const fetchsCommentCampaign = (campaign_id, content = '', offset = 0, limit = 30, callback, afterLive = false) =>
   async (dispatch, getState) => {
      const { page: pageFb } = getState();
      const params = {
         fb_page_id: pageFb.social_id,
         campaign_id,
         offset,
         limit,
         content
      }
      const qs = objToQueryString(params);
      const endPoint = `${afterLive ? END_POINT.CONVERSATIONS_POSTS : END_POINT.CONVERSATIONS_CAMPAIGN}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: COMMENT_TYPE.FETCHS,
            payload: response.data
         });
         if (callback) {
            callback(response.data)
         }
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const fetchsMoreCommentCampaign = (campaign_id, content, offset = 0, limit = 30, callback, afterLive = false) =>
   async (dispatch, getState) => {
      const { page: pageFb } = getState();
      const params = {
         fb_page_id: pageFb.social_id,
         campaign_id,
         offset,
         limit,
         content
      }
      const qs = objToQueryString(params);
      const endPoint = `${afterLive ? END_POINT.CONVERSATIONS_POSTS : END_POINT.CONVERSATIONS_CAMPAIGN}?${qs}`;
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: COMMENT_TYPE.FETCHS_MORE,
            payload: response.data
         });
         if (callback) {
            callback(response.data)
         }
      }).catch((error) => {
         dispatch(setError(error.message));
      });
   }